/** Transform axios error into app readable error
 *  @param err {Error} Network error from axios
 *  @return {Error} Error with: message, data and errors
 */
export function generateError(err) {
  const error = new Error(err?.message || 'An error occurred')

  error.message = err?.message || 'An error occurred'
  error.data = err?.data || null
  error.errors = err?.errors || []

  return error
}
